export const DASHED_BORDER = {
  borderStyle: "dashed",
  borderRadius: "8px",
  borderColor: "lightgrey",
  borderWidth: "2px",
};
